// extracted by mini-css-extract-plugin
export var logo = "_7e-2";
export var logoWrapper = "_7e-1";
export var strip = "_7e-0";